{
	"activating": "Attivazione…",
	"description": "Imposta una password e completa l'attivazione del tuo account.",
	"email": "Email",
	"failed": {
		"link_closed": {
			"description": "È scaduto, è stato revocato o è stato usato mentre questa pagina era aperta. Chiedi a chi ti ha invitato di inviartene uno nuovo.",
			"title": "Questo invito non è più utilizzabile"
		},
		"password_rejected": {
			"description": "Non rispetta le regole sulle password della console. Scegline un'altra: non è cambiato nulla.",
			"title": "Password rifiutata"
		},
		"provider_unavailable": {
			"description": "Il tuo invito è intatto. Invia di nuovo il modulo tra un momento.",
			"title": "Non siamo riusciti a impostare la password"
		},
		"rate_limited": {
			"description": "Aspetta qualche minuto prima di riprovare.",
			"title": "Troppi tentativi"
		},
		"unavailable": {
			"description": "Si è verificato un errore. Invia di nuovo il modulo.",
			"title": "Non siamo riusciti a completare l'attivazione"
		}
	},
	"first_name": "Nome",
	"first_name_required": "Inserisci il nome.",
	"handing_over": {
		"description": "Inserisci la password che hai appena scelto.",
		"signed_in": "Ti stiamo portando nella console…",
		"title": "Ti stiamo portando all'accesso…"
	},
	"last_name": "Cognome",
	"last_name_required": "Inserisci il cognome.",
	"loading": "Verifica dell'invito in corso…",
	"password": "Password",
	"password_policy": {
		"rules": {
			"digits": "contenga almeno {{value}} cifra",
			"length": "sia lunga almeno {{value}} caratteri",
			"lowerCase": "contenga almeno {{value}} lettera minuscola",
			"passwordHistory": "non sia una delle tue ultime {{value}} password",
			"specialChars": "contenga almeno {{value}} carattere speciale",
			"upperCase": "contenga almeno {{value}} lettera maiuscola"
		},
		"title": "La console richiede una password che:"
	},
	"password_required": "Scegli una password.",
	"refused": {
		"already_used": {
			"description": "Il tuo accesso è già attivo. Accedi con l'email e la password che hai scelto.",
			"go_to_login": "Vai all'accesso",
			"title": "Invito già usato"
		},
		"expired": {
			"description": "Gli inviti valgono per un tempo limitato. Chiedi a chi ti ha invitato di inviartene uno nuovo.",
			"title": "Questo invito è scaduto"
		},
		"invalid": {
			"description": "Controlla di aver aperto il link completo dall'email. Se il problema resta, chiedi a chi ti ha invitato di inviartene uno nuovo.",
			"title": "Questo link di invito non funziona"
		},
		"rate_limited": {
			"description": "Aspetta qualche minuto, poi riapri il link dall'email.",
			"title": "Troppi tentativi"
		},
		"unavailable": {
			"description": "Il tuo invito non è cambiato. Ricarica la pagina per riprovare.",
			"title": "Non siamo riusciti a verificare l'invito"
		}
	},
	"submit": "Imposta la password e continua",
	"title": "Hai ricevuto un invito alla console"
}
